import React from "react";

import FIlterSelect from "../filter-select";
import Input from "../input";
import { I_Customer } from "../../pages/customers/types";
import { formatDate } from "../../utilz/function";
import { I_Requisition } from "../../pages/requisition/types";

interface OrderDetailsProps {
  control: any;
  errors: any;
  reqs?: I_Requisition | null;
}

const RequisitionInformation: React.FC<OrderDetailsProps> = ({ reqs }) => {
  return (
    <div className="flex flex-col gap-5">
      <div className="items-center gap-4">
        <Input
          name="createdby"
            value={reqs?.createdBy?.username || ""}
          className="w-full"
          label="Requested By"
          placeholder="John Doe"
        />

        <div className="mt-3">
          <label className="block text-sm font-medium text-gray-700 ">
            Request Date
          </label>
          <input
            value={reqs?.createdAt ? formatDate(reqs.createdAt) : ""}
            className="w-full border mt-2 rounded-full h-[48px] px-3 border-[#9D9898]"
          />
        </div>
        <div className="mt-3">
          <label className="block text-sm font-medium text-gray-700 ">
            Urgency Level
          </label>
          <input
            value={reqs?.urgencyLevel || ""}
            className="w-full border mt-2 rounded-full h-[48px] px-3 border-[#9D9898]"
          />
        </div>
      </div>
      {/* Customer field is handled in parent component */}

      {/* <FIlterSelect
        name="urgencyLevel"
        options={[
          { value: "high", label: "High" },
          { value: "low", label: "Low" },
        ]}
        value={reqs?.urgencyLevel || ""}
        className="w-full"
        label="Urgency Level"
      /> */}
      
    </div>
  );
};

export default RequisitionInformation;
